import React from 'react';
import styled from 'styled-components';
import { DeviceType, SubscriptionStatus } from '../../../shared/enum/EnumRepository';
import { useDeviceStore } from '../../../shared/store/deviceStore';
import { MemberFilterData } from '../../../shared/dto/EntityRepository';
import { UniversalCheckbox } from '../../../shared/component/UniversalCheckbox';

const SUBSCRIPTION_OPTIONS = Object.values(SubscriptionStatus);

interface FilterStationMemberSubscriptionProps {
  currentFilter: MemberFilterData;
  setCurrentFilter: (filter: MemberFilterData) => void;
}

const FilterStationMemberSubscription: React.FC<FilterStationMemberSubscriptionProps> = ({ currentFilter, setCurrentFilter }) => {
  const { deviceType } = useDeviceStore();
  const subscriptionAll = SUBSCRIPTION_OPTIONS.every((status) => currentFilter.subscription[status]);

  const handleSubscriptionChange = (status: SubscriptionStatus) => {
    setCurrentFilter({
      ...currentFilter,
      subscription: { ...currentFilter.subscription, [status]: !currentFilter.subscription[status] },
    });
  };

  const handleSubscriptionChangeAll = () => {
    const next = !subscriptionAll;
    setCurrentFilter({
      ...currentFilter,
      subscription: Object.fromEntries(
        SUBSCRIPTION_OPTIONS.map((status) => [status, next])
      ) as MemberFilterData['subscription'],
    });
  };

  return (
    <SubscriptionFilterComp>
      <SubscriptionSubTitle $isMobile={deviceType === DeviceType.MOBILE}>Subscription</SubscriptionSubTitle>
      <SubscriptionFilterList $isMobile={deviceType === DeviceType.MOBILE}>
        {SUBSCRIPTION_OPTIONS.map((status) => (
          <CheckboxComp key={status}>
            <UniversalCheckbox
              checked={currentFilter.subscription[status]}
              onChange={() => handleSubscriptionChange(status)}
            />
            {status}
          </CheckboxComp>
        ))}
        <CheckboxComp>
          <UniversalCheckbox
            checked={subscriptionAll}
            onChange={handleSubscriptionChangeAll}
          />
          Select ALL
        </CheckboxComp>
      </SubscriptionFilterList>
    </SubscriptionFilterComp>
  );
};


export default FilterStationMemberSubscription;


const SubscriptionSubTitle = styled.div<{ $isMobile: boolean }>`
  margin-bottom: ${({ $isMobile }) => $isMobile ? '2vh' : '1.2vh'};
  ${({ theme, $isMobile }) => $isMobile ? theme.typography.Body_02_1 : theme.typography.Body_03_1};
`;

const SubscriptionFilterComp = styled.div`
  display: flex;
  flex-direction: column;
`;

const SubscriptionFilterList = styled.div<{ $isMobile: boolean }>`
  display: ${({ $isMobile }) => $isMobile ? 'grid' : 'flex'};
  flex-direction: column;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ $isMobile }) => $isMobile ? '1vh' : '4px'};
`;

const CheckboxComp = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 4px;
  user-select: none;
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme }) => theme.colors.color_Gray_03};
`;
